import React from "react"
import * as H from "history"
import { RouteProps } from "react-router-dom"
import { useSelector } from "react-redux"
import { Route, Redirect } from "react-router-dom"
import { isFetchingUser } from "../selectors"

interface LoadingUserRouteProps {
  renderComponent: React.ReactElement
  exact?: boolean
  path: H.LocationDescriptor
  redirect: string
  signInWithGoogle?: () => void
}

export const LoadingUserRoute = (
  props: Partial<RouteProps & LoadingUserRouteProps>,
) => {
  const { renderComponent, exact, path, redirect, ...restProps } = props
  const isFechingUser = useSelector(isFetchingUser)

  if (!renderComponent || !redirect) {
    return null
  }

  if (isFechingUser) {
    return (
      <Route
        exact={exact}
        path={path}
        render={(routeProps) => {
          return React.cloneElement(renderComponent, {
            ...routeProps,
            ...restProps,
          })
        }}
      />
    )
  } else {
    return <Redirect to={redirect} />
  }
}
